import { render, staticRenderFns } from "./high-formwork-detail.vue?vue&type=template&id=d518b4cc&"
import script from "./high-formwork-detail.vue?vue&type=script&lang=js&"
export * from "./high-formwork-detail.vue?vue&type=script&lang=js&"
import style0 from "./high-formwork-detail.vue?vue&type=style&index=0&id=d518b4cc&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports